/* eslint-disable no-param-reassign */
/**
 * @typedef {import('vuex').Module} VuexModule
 */

import {
  createNseDataHandleMutations,
  createNseEventHandler,
  createNseCloneAction,
  createNseBasicActions,
} from '../helpers/store-tools';
import * as nseApi from '../helpers/nse-api';

/**
 * @type {VuexModule}
 */
export const m = {
  namespaced: true,
  state: () => ({
    // 存所有的 action
    actions: [],
    idMap: {},
    // group by parent
    groupByParent: {},
  }),
  mutations: {
    // 建立操作 rep_action 的相關 mutations
    ...createNseDataHandleMutations({
      name: 'rep_action',
      stateKey: 'actions',
      getId: (data) => data.id,
      getParentId: (data) => data.branchId,
    }),
  },
  actions: {
    ...createNseEventHandler({
      createFuncName: 'createRepAction',
      updateFuncName: 'updateRepAction',
      deleteFuncName: 'deleteRepAction',
    }),
    ...createNseBasicActions({
      name: 'rep_action',
      createFunc: 'createRepAction',
      updateFunc: 'updateRepAction',
      deleteFunc: 'deleteRepAction',

      handleOrderBy: 'branchId',
      handleName: true,
    }),
    cloneRepActions: createNseCloneAction({
      name: 'rep_action',
      parentKey: 'branchId',
      cloneKey: 'createRepAction',
      cloneChildren: [],
    }),
  },
};

export default m;
